import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import get from 'lodash-es/get';

type dropDownDataType = {
    buttonTitle: string;
    listItems: { href: string; title: string }[];
    dropdownMenuID: string;
};

@Component({
    selector: 'app-resource-center-dropdown',
    templateUrl: './resource-center-dropdown.component.html',
    styleUrls: ['./resource-center-dropdown.component.scss'],
    standalone: false,
})
export class ResourceCenterDropdownComponent {
    @Input() initialDropdownTitle: string;
    @Input() dropdownData: dropDownDataType;
    @Input() returnToHomepageLink: boolean;
    currentTitle: string;

    constructor(private router: Router) {}

    // RouterLink on a non-anchor element only reacts to clicks
    navigate(href: string) {
        this.router.navigateByUrl(href);
    }

    get(ob: any, args: any, defaultValue?: any) {
        return get(ob, args, defaultValue);
    }
}
